import { render, staticRenderFns } from "./RecorderMusic.vue?vue&type=template&id=68d240e7&scoped=true"
import script from "./RecorderMusic.vue?vue&type=script&lang=js"
export * from "./RecorderMusic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d240e7",
  null
  
)

export default component.exports